export const PHONE_PREFIXES = [
  {
    title: "🇮🇩 +62",
    value: "62",
  },
];
